<template>
  <v-container class="contenedor_principal">
    <v-container class="continer_recuperar">
      <p class="txt_indicaciones" v-if="usuario.validacion =='correo'">        
        <span  >Ingresa el código de verificación que enviamos a tu cuenta 
          de correo eletrónico</span>
          <br>
        <span class="font-weight-bold" >
          {{ usuario.correo}}
        </span>
     </p>
      <p class="txt_indicaciones"  v-if="usuario.validacion =='sms'">        
        <span  >Ingresa el código de verificación que enviamos al número</span>        
        <span class="font-weight-bold">
          {{ usuario.telefono}}
        </span>    
     </p>     
      <v-row class="d-flex justify-center ">
        <div
          class="btn-registrate subtitle-1 pb-2"
          @click="$router.push('/opciones_registro');$router.push('/Registrarse')"
           v-if="usuario.validacion =='correo'"
        > Modificar mi cuenta de correo electrónico o datos</div>
        <div
          class="btn-registrate subtitle-1 pb-2"
          @click="$router.push('/opciones_registro');$router.push('/Registrarse')"
           v-else
        > Modificar mi número de telefono o datos </div>        
      </v-row>         
      <v-row justify="center">
        <CodeInput
          :loading="false"
          :fields="4"
          class="input"
          v-on:complete="onComplete"
          :key="componentKey"
        />
      </v-row>
      <br />
      <p
        class="cronometro"
        style="font-size:12px;"
      >Tú código vence en: {{formato_tiempo(duracion_codigo)}}</p>
      <v-row class="d-flex justify-center ">
        <div
          v-if="mostrar_reenviar"
          class="btn-registrate subtitle-1 pt-2"
          @click="reenviar()"
        > Reenviar</div>
      </v-row>      
    </v-container>

    <v-footer absolute class="font-weight-medium" padless>
      <v-btn x-large color="#58C4B5" dark style="width: 100%;" @click="submit('cambio')">VERIFICAR</v-btn>
    </v-footer>
  </v-container>
</template>

<script>
// import BarraNavegacion from '../components/BarraNavegacion/BarraNavegacion.vue'
import Vista from "@/objetos/vista";
import Verificar from "@/objetos/verificar";
/**https://www.npmjs.com/package/vue-verification-code-input */
import CodeInput from "vue-verification-code-input";
import Conexion_api from "@/api/Conexion_api.js";
import Usuario from "@/objetos/usuario";
import registrar_contacto from "@/funciones/registrar_contacto.js"
import datos_registro from "@/objetos/datos_registro"

// import Usuario from "@/objetos/usuario";
// elozano@powerstreet.com.mx
export default {
  components: {
    CodeInput
  },
  data: () => ({
    soloNumeros: [v => !isNaN(v) || "El valor debe ser numérico."],
    alert: true,
    duracion_codigo: 121, // El tiempo de duracion es de 120 segundos == 2 minutos
    verificar: Verificar,
    componentKey: 0,
    codigo_valido: false,
    usuario:Usuario,
    mostrar_reenviar: false
  }),
  mounted() {
    Vista.nombre = "/verificar";
    this.$root.$on("finaliza_cronometro", finalizar => {
      if (finalizar) this.duracion_codigo = 0;
    });
    this.cronometro(); //ejecutar despues de que se envíe el codigo..
    if(Usuario.codigo_valido) this.$router.push("/cambio");
  },
  computed: {},
  methods: {
    submit(nombre) {
      if (!this.codigo_valido) return;
      this.$v.$touch();
      let ruta = `/${nombre.toLowerCase()}`;
      if (this.pagina != nombre) this.$router.push(ruta);
    },
    clear() {
      this.$v.$reset();
    },
    cronometro() {
      if (this.codigo_valido) this.duracion_codigo = null;
      if (this.duracion_codigo == 0) {
        this.$root.$emit('snackbar',{ color:"error", texto:"Se agoto el tiempo."})   
        this.mostrar_reenviar = true 
      } else {
        this.duracion_codigo -= 1;
        setTimeout(() => {
          this.cronometro();
        }, 1000);
      }
    },
    formato_tiempo(seconds) {
      const format = val => `0${Math.floor(val)}`.slice(-2);
      //   const hours = seconds / 3600
      const minutes = (seconds % 3600) / 60;
      return [minutes, seconds % 60].map(format).join(":");
    },
    onComplete(codigo) {
      if(!this.duracion_codigo) {
          this.$root.$emit('snackbar',{ color:"error", texto:"Se agoto el tiempo."})   
          return;
      }
      Conexion_api({
        body: {          
          correo: Usuario.correo,
          codigo: Number(codigo),
          validacion : Usuario.validacion,
          telefono :Number(Usuario.telefono),
          usuario:this.usuario,
        },
        evento: "login/valida_codigo" 
      }).then(respuesta => {
        this.codigo_valido = false;
        if (respuesta.data.error) {
          console.error(respuesta.data.error);
          this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})  
          this.reinciar() 
          return;
        } else if (!respuesta.data.usuario) {
          this.$root.$emit('snackbar',{ color:"error",texto: "El código no coincide, intenta de nuevo."})   
          return
        } 
        
        this.codigo_valido = true;
        Usuario.codigo_valido = true;          
        this.$root.$emit('snackbar',{ color:"green", texto:"Validación correcta."})        
        if(Usuario.recuperar){        
          this.$router.push("/cambio")   
          return
        } 
        Usuario.coordenadas = respuesta.data.usuario.coordenadas
        Usuario.nombre = respuesta.data.usuario.nombre
        Usuario.nombre_vista = respuesta.data.usuario.nombre
        Usuario.direccion = respuesta.data.usuario.direccion
        Usuario.rut = respuesta.data.usuario.rut            
        Usuario.coordenadas = respuesta.data.usuario.coordenadas        
        this.$cookie.set('pwst', respuesta.data.token, { expires: '1h' });
        
        if(this.usuario.rut) {
          datos_registro.telefono = this.usuario.telefono
          datos_registro.correo = this.usuario.correo
          datos_registro.rut = this.usuario.rut
          datos_registro.nuevo_registro = true
          datos_registro.coordenadas = this.usuario.coordenadas
          registrar_contacto(datos_registro);
        }
        this.$router.push("/distribuidor") 
            
        });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    reinciar(){      
      this.forceRerender();      
      this.duracion_codigo = 121 
      this.cronometro()
    },
    reenviar(){
      this.reinciar()
        Conexion_api({
          body: {
            ...this.usuario
          },
          evento: "login/enviar_codigo"
        })
          .then(respuesta => {
            this.mostrar_loader = false;
            if (respuesta.data.error) {
              console.error(respuesta.data.error);
              this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})   
              return;
            } else if (respuesta.data.exito) {
              this.$root.$emit('snackbar',{ 
                color:"green",
                texto: "Se le ha sido enviado  un código de verificación." })   
            }
          })
          .catch(err => {
            this.mostrar_loader = false;
            err = String(err);
            console.error(err);
          });      
    }
  }
};
</script>

<style scoped>
.contenedor_principal {
  display: table;
  height: 100%;
}
.continer_recuperar {
  border-radius: 10px;
  margin-top: 12%;
  width: 100%;
  display: table-cell;
  vertical-align: middle;
}
.txt_indicaciones {
  text-align: center;
  color: #515c6f;
  font-size: 15px;
  margin-top: -20%;
}
.cronometro {
  text-align: center;
  color: #515c6f;
  font-size: 12px;
}
</style>